import useListenServer from '@/service/useListenServer';
import { useNodes } from '@/service/useNodes';
import { useWebSocket } from 'ahooks';
import { localMemory } from 'localmemory';
import { FC } from 'react';
import { sessionConfigCache } from '@/store/userStore';
import useUserStore from '@/store/userStore';

const MessageBus: FC<{}> = memo(
  () => {
    const userStore = useUserStore();
    const { nodes } = useNodes();

    if (!userStore.sessionConfig.token) {
      return;
    }

    useListenServer(
      `${nodes.ws?.[0]}?lbeToken=${userStore.sessionConfig.token}&lbeTession=${userStore.sessionConfig?.sessionId}`
    );

    return <></>;
  },
  () => {
    return true;
  }
);

export default MessageBus;
